<template>
  <IonFooter class="mobile-web-footer">
    <div class="mobile-web-toolbar">
      <!-- Menu toggle -->
      <IonButton fill="clear" class="nav-btn" @click="toggleDrawer">
        <IonIcon :icon="menuOutline" slot="icon-only" />
      </IonButton>

      <!-- Search -->
      <ZenQuickSearchMobile v-if="shouldShowQuickSearch" @navigate="handleSearchNavigation" />

      <!-- Home -->
      <IonButton fill="clear" class="nav-btn" @click="navigateToHome">
        <IonIcon :icon="homeOutline" slot="icon-only" />
      </IonButton>

      <!-- Chat Button -->
      <IonButton v-if="shouldShowChat" fill="clear" @click="navigateToChat" class="nav-btn">
        <IonIcon :icon="chatbubbleEllipsesOutline" slot="icon-only" />
      </IonButton>

      <!-- User Avatar -->
      <UserAvatarPopover :current-theme="currentTheme" @theme-toggled="onThemeToggled" />
    </div>
  </IonFooter>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import { IonFooter, IonButton, IonIcon } from '@ionic/vue';
import { menuOutline, chatbubbleEllipsesOutline, homeOutline } from 'ionicons/icons';
import { useRouter } from 'vue-router';
import { useUIStore } from '@/common/stores/uiStore';
import { useLayout } from '@/layouts/composables/useLayout';
import { storageService } from '@/common/services/storage/storageService';
import type { SearchResult } from '@/common/composables/useQuickSearch';
import UserAvatarPopover from '@/features/common/user/user-avatar/components/UserAvatarPopover.vue';
import ZenQuickSearchMobile from '@/common/components/ui/quick-search/ZenQuickSearchMobile.vue';

const router = useRouter();
const uiStore = useUIStore();
const { shouldShowQuickSearch, shouldShowChat } = useLayout();

const currentTheme = ref('light');

// Actions
function toggleDrawer() {
  uiStore.toggleDrawer();
}

function navigateToHome() {
  router.push('/home');
}

function navigateToChat() {
  router.push('/chat');
}

function handleSearchNavigation(result: SearchResult) {
  // Navigation déjà gérée par le composable useQuickSearch
}

function onThemeToggled() {
  currentTheme.value = currentTheme.value === 'light' ? 'dark' : 'light';
}

onMounted(() => {
  const savedTheme = storageService.getItem('theme');
  if (savedTheme) {
    currentTheme.value = savedTheme;
    if (savedTheme === 'dark') {
      document.body.classList.add('dark');
    }
  }
});
</script>

<style scoped>
.mobile-web-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: var(--ion-background-color);
  box-shadow: var(--ion-box-shadow);
  padding-bottom: env(safe-area-inset-bottom, 0);
}

.mobile-web-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 56px;
  padding: 0 8px;
}

.nav-btn {
  --padding-start: 12px;
  --padding-end: 12px;
  flex: 1;
  max-width: 80px;
}

.nav-btn ion-icon {
  font-size: 24px;
  color: var(--ion-text-color);
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .mobile-web-toolbar {
    padding: 0 4px;
  }

  .nav-btn {
    --padding-start: 8px;
    --padding-end: 8px;
  }
}
</style>
